import React, { useEffect, useState } from 'react';
import HeadTitle from '../../components/HeadTitle';
import SubscriptionPlans from '../../components/financials/SubscriptionPlans';
import RevenueAnalytics from '../../components/financials/RevenueAnalytics';
import SubscribedUserList from '../../components/financials/SubscribedUserList';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import FinancialsPlansSkeleton from './FinancialsPlansSkeleton';

const FinancialsPlans = () => {
  const [loading, setLoading] = useState(true);
  const [components] = useState([
    {
      id: 1,
      imageSrc: '/assets/images/admin-panel/financials.svg',
      text: 'Financials',
      description:
        'Comprehensive insights into subscription plans, payments, and revenue streams.',
    },
  ]);

  useEffect(() => {
    // Simulate API load time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <FinancialsPlansSkeleton />;
  }

  return (
    <div>
      {/* Dynamically Render Components */}
      {components.map((component) => (
        <HeadTitle
          key={component.id}
          imageSrc={component.imageSrc}
          text={component.text}
          description={component.description}
        />
      ))}
      <SearchFilter isHideUserManagement={false} />
      <div className="">
        <SubscriptionPlans />
      </div>
      <div className="">
        {/* <SubscriberWisePriceWise /> */}
      </div>
      <div className="">
        <RevenueAnalytics />
      </div>
      {/* <div className="py-24">
        <RealTimeChart />
      </div> */}
      <div className="py-32">
        <SubscribedUserList />
      </div>
    </div>
  );
};

export default FinancialsPlans;
